<section class="sana-auth auth-page">
  <div class="auth-card">
    <img
      src="/img/logo-without-slogan.png"
      alt="sanactivo"
      class="logo"
    />

    <h2 class="title">Neues Passwort festlegen</h2>
    <p class="subtitle">Wähle ein neues Passwort für dein Konto.</p>

    <form
      autocomplete="on"
      [formGroup]="passwordResetForm"
      (ngSubmit)="onSubmit()">

      <label class="field">
        <span>Neues Passwort</span>
        <div class="password-wrapper">
          <input
            class="input"
            id="password"
            name="password"
            autocomplete="new-password"
            autofocus
            [type]="showPassword() ? 'text' : 'password'"
            [class.is-invalid]="passwordResetForm.controls.newPassword.invalid && passwordResetForm.controls.newPassword.touched"
            [formControl]="passwordResetForm.controls.newPassword" />
          <button
            type="button"
            class="password-toggle"
            [attr.aria-label]="showPassword() ? 'Passwort verbergen' : 'Passwort anzeigen'"
            (click)="togglePassword()">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </button>
        </div>

        @if (passwordResetForm.controls.newPassword.hasError('required') && passwordResetForm.controls.newPassword.touched) {
          <span class="field-error">Bitte gib ein neues Passwort ein.</span>
        } @else if (passwordResetForm.controls.newPassword.hasError('minlength') && passwordResetForm.controls.newPassword.touched) {
          <span class="field-error">Das Passwort muss mindestens 8 Zeichen lang sein.</span>
        }
      </label>

      <div class="hint">Mindestens 8 Zeichen.</div>

      @if (errorMessage !== null) {
        <div class="form-error" role="alert">
          {{ errorMessage }}
        </div>
      }

      <div class="actions">
        <button type="submit" class="btn btn-primary" [disabled]="isSubmitting()">
          {{ isSubmitting() ? 'Wird gespeichert …' : 'Passwort speichern' }}
        </button>
      </div>
    </form>

    <div class="auth-links centered">
      <a [routerLink]="['/login']">Zurück zur Anmeldung</a>
    </div>
  </div>

  <div class="auth-copyright">© {{ currentYear }} Sanactivo</div>
</section>
